import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api, { formatError } from '../lib/api';
import { toast } from 'sonner';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get('token') || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 4) return toast.error('Password too short');
    if (password !== confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      toast.success('Password reset. Please sign in.');
      navigate('/login');
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid-pattern bg-[#F4F4F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-zinc-900 shadow-brutal p-8">
        <div className="mb-6">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">RECOVERY</div>
          <h2 className="font-display text-3xl font-black tracking-tighter">Reset password</h2>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">Reset token</label>
            <input data-testid="reset-token" value={token} onChange={(e) => setToken(e.target.value)} required className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-3 bg-white font-mono text-xs" />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">New password</label>
            <input data-testid="new-pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={4} className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-3 bg-white" />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">Confirm new password</label>
            <input data-testid="confirm-pwd" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={4} className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-3 bg-white" />
          </div>
          <button data-testid="reset-submit" type="submit" disabled={loading} className="w-full bg-[#002FA7] text-white py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#002088] disabled:opacity-60 transition-colors">
            {loading ? 'Resetting...' : 'Reset Password →'}
          </button>
        </form>
        <div className="mt-6 pt-5 border-t border-zinc-200 text-sm text-zinc-600">
          <Link to="/login" data-testid="back-login" className="font-bold text-[#002FA7] underline decoration-2 underline-offset-2">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
